module.exports = {"141021100":"乐昌镇","141021101":"史村镇","141021102":"曲村镇","141021103":"高显镇","141021104":"里村镇","141021200":"北董乡","141021201":"杨谈乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141021.json
// module id = 320
// module chunks = 0